<template>
    <div>
        <a-table :columns="columns" 
                 :data-source="menus" 
                 :pagination="{pageSize: pageSize}"
                 rowKey="menuId"
        >

            <template slot="index" slot-scope="text, record, index">
                <p>{{ index + 1 }}</p>
            </template>


            <template slot="actions" slot-scope="record">
				<a-button-group>
					<a-button shape="circle" icon="form" size="small" @click="handleBtnEdit(record)"/>
				</a-button-group>
			</template>

        </a-table>
        <menu-edit-view-modal ref="menuEditModal"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { OPEN_MENU_EDIT_VIEW_EVENT } from '../../../common/events/componentEvents.js'
import MenuEditViewModal from './MenuEditViewModal.vue'
export default {
    inject : ['eventBus'],
    components: { 
        MenuEditViewModal
    },

    computed :{
        ...mapState({
            menus : state => state.menus.menus
        })
    },

    data () {

        return {
            pageSize: 5,
            columns : [
                {
					title: '#',
					dataIndex: 'index',
                    scopedSlots: { customRender: 'index' },
				},
                {
					title: 'NAME',
					dataIndex: 'menuName',
				},
                {
			        title : 'ACTIONS',
			        scopedSlots : { customRender: 'actions'},
			        fixed: 'right'
		        }
            ]
        }
    },

    methods : {
        handleBtnEdit(record) {

            //
            //open menu edit modal this.$refs['productAddModal'].showModal();
            //

            //
            //SET CURRENT MENUID STATE
            //
            this.$store.commit('menus/SET_CURRENT_MENUID_STATE', record.menuId)
            this.$refs['menuEditModal'].showModal(record.menuId);
            //this.eventBus.$emit(OPEN_MENU_EDIT_VIEW_EVENT, record );

        }
    },

   
}
</script>

<style>

</style>